import { render, staticRenderFns } from "./PromoCreation.vue?vue&type=template&id=20a3aeb6"
import script from "./PromoCreation.vue?vue&type=script&lang=js"
export * from "./PromoCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports